import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import {Server, Dictionary, helper}  from "./../app.js"; 

export default class ShoreConnSelecter extends PureComponent 
{
    constructor (props)
    {
        super(props);

        //console.log(this.props.init_connector);

        const hasConnector = !helper.isNotObjectOrEmpty(this.props.init_connector);

        this.state = {
            connectors: {},
            id: hasConnector ? this.props.init_connector.name : '',
            loading: false 
        };

        this.isActive = this.isActive.bind(this);
        this.selectConnector = this.selectConnector.bind(this);
    }
    get connector ()
    {
        const id = this.state.id;
        let connector = null;

        if (id && id in this.state.connectors)
        {
            connector = this.state.connectors[id];
        }
        return connector;
    }    
    isActive ()
    {
        return this.props.shelf_articul;
    }
    selectConnector (e)
    {
        const id = e.target.value,
            newConnector = id ? helper.copyObject(this.state.connectors[id]) : null;

        this.setState({id});

        //console.log('ShoreConnSelecter', id, newConnector, this.state.connectors);

        if (!helper.isNotObjectOrEmpty(newConnector))
        {
            newConnector.quantity = 1;
            //console.log('shore_connector in ShoreConnSelecter', newConnector);
            this.props.on_select(newConnector, 'shore_connector', false);
        } 
        else
            this.props.on_select(null, 'shore_connector', false);
    }
    loadConnectors ()
    {
        if (this.isActive())
        {   
            let studArticul = this.props.stud_articul;

            if (!studArticul)    
            {
                studArticul = this.props.shelf_articul;
            }

            this.setState({loading: true});

            Server.instance
                .query('get_shore_connectors', {stud_articul: studArticul})
                .then((recievedConnectors) =>
                {
                    const connectors = {};
                    recievedConnectors.forEach(function (connectorFields)
                    {
                        const connector = {},
                            variantName = connectorFields.variantName;

                        helper.fillItem(connectorFields, connector);

                        if (!(variantName in connectors))
                        {
                            connectors[variantName] = {
                                name: variantName,
                                products: [connector]
                            }
                        }
                        else
                            connectors[variantName].products.push(connector);
                    });
                    //console.log(connectors);

                    this.setState({connectors, loading: false});
                })
                .catch(() => this.setState({connectors: {}, loading: false}));
        }
    }
    componentDidMount ()     
    {
        this.loadConnectors();
    }
    render () 
    {
        let carrierType = this.props.carrier_type,
            connectorsListIDs = Object.keys(this.state.connectors),
            connectorsList = [],
            disabled = false;

        if (carrierType)
        {
            carrierType = `'${carrierType}'`;
            const carrierTypes = Dictionary.instance.get('carriers');

            if (carrierType in carrierTypes)
            {
                const carrier = carrierTypes[carrierType];

                connectorsList = connectorsListIDs
                                        .map(id =>
                                        {
                                            let connectorName = id,
                                                carrierFitRegExp = new RegExp(`^(.+?)\\[${carrier}\\]$`),
                                                connectorFit4Carrier = false,
                                                regRes = null;

                                            if (regRes = connectorName.match(carrierFitRegExp))
                                            {
                                                connectorName = regRes[1].trim();
                                                connectorFit4Carrier = true;
                                            }
                                            else
                                            {
                                                carrierFitRegExp = new RegExp(`\\[.+?\\]$`);
                                                if (!connectorName.match(carrierFitRegExp))
                                                {
                                                    connectorFit4Carrier = true;
                                                }
                                            }
                                            return connectorFit4Carrier ? <option key={id} value={id}>{connectorName}</option> : null;

                                        }).filter(item => null !== item);                                        
            }
        }
        else
            connectorsList = connectorsListIDs.map(id => 
            {
                const connectorName = id;
                return <option key={id} value={id}>{connectorName}</option>
            });

        connectorsList.unshift(<option key="none" value="">Выберите крепление монтажной системы</option>);
        disabled = !this.isActive() || !connectorsList.length;

        return (<>
            <Form.Row>
                <Form.Group as={Col} md={8}>
                    <Form.Label className={disabled ? 'text-muted' : ''}>Крепление монтажной системы к несущей:{this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''}</Form.Label>
                    <Form.Control onChange={this.selectConnector} value={this.state.id} disabled={disabled} as="select" custom>
                        {connectorsList}
                    </Form.Control>
                </Form.Group>
            </Form.Row>
        </>);
    }
}